import { Record } from 'immutable';
import _ from 'lodash';

import { resolve } from '../../helpers/LinkMapper';
import Address from '../customer/Address';
import { CardTypes } from '../../constants/AppConstants';


const defaults = {
    token: null,
    amount: null,
    nickname: null,
    cardHolderName: null,
    startDate: null,
    expiryDate: null,
    email: null,
    phone: null,
    store: false,
    address: new Address()
};


class Card extends Record(defaults) { // eslint-disable-line new-cap

    static fromJSON (json = {}) {
        return new Card({
            token: resolve(json.token).with(String),
            amount: resolve(json.amount).with(Number),
            nickname: resolve(json.nickname).with(String),
            cardHolderName: resolve(json.cardHolderName).with(String),
            startDate: resolve(json.startDate).with(String),
            expiryDate: resolve(json.expiryDate).with(String),
            email: resolve(json.email).with(String),
            phone: resolve(json.phone).with(String),
            store: resolve(json.stored).with(Boolean),
            address: resolve(json.address).as(Address)
        });
    }

    static getType (pan = null) {
        return pan ? _.findLastKey(CardTypes, (r) => pan.match(r)) : null;
    }

}


export default Card;



// WEBPACK FOOTER //
// ./src/records/payment/Card.js